import { EGESlimCachePBFResponseRow, EGESuperSummarizedPBFExt } from '@types';

// Type guard for EGESuperSummarizedPBFExt (has `epochms`)
export const isEGESuperSummarizedPBFExt = (item: EGESuperSummarizedPBFExt | EGESlimCachePBFResponseRow): item is EGESuperSummarizedPBFExt => {
  return 'epochms' in item;
};

export const isEGESuperSummarizedPBFExtArray = (items: (EGESuperSummarizedPBFExt | EGESlimCachePBFResponseRow)[]): items is EGESuperSummarizedPBFExt[] => {
  return items[0] && 'epochms' in items[0];
};
